module.exports = __webpack_public_path__ + "img/tsft_seafarmstake.c071182.png";